import request from '@/api/request'
import { getRequestData } from "@/api/requestProtocol" //引入外链方法

export function getRequest (apiEndpoint, data) {
    let bizData = data
    apiEndpoint =process.env.VUE_APP_BASE_API+"/h5AccessMgt/"+apiEndpoint;
    let requestDataJson = getRequestData(bizData);
    return request({
        url: apiEndpoint,
        method: 'post',
        data: requestDataJson
    })
}

export function getRequest20 (apiEndpoint, data) {
    let bizData = data
    apiEndpoint =process.env.VUE_APP_BASE_API+"/h5AccessMgt20/"+apiEndpoint;
    let requestDataJson = getRequestData(bizData);
    return request({
        url: apiEndpoint,
        method: 'post',
        data: requestDataJson
    })
}

export function getRequestCommon (apiEndpoint, data) {
    let bizData = data
    
    let requestDataJson = getRequestData(bizData);
    return request({
        url: apiEndpoint,
        method: 'post',
        data: requestDataJson
    })
}


export function getRequestNotGateWay (apiEndpoint, data) {
    let bizData = data
    
    let requestDataJson = bizData;
    return request({
        url: apiEndpoint,
        method: 'post',
        data: requestDataJson
    })
}

//export default getRequest;